// @ts-nocheck
// tool-site-speed.js — Site Speed Revenue Calculator behaviour (SSM-631).
//
// Math ported verbatim from the Vercel app's src/lib/siteSpeed.ts. The two model
// constants are read off the root's data attributes so the JS and the displayed prose
// in snippets/tool-site-speed.liquid come from the same Liquid assignment.
//
// Every step is already in the DOM; this only toggles visibility and writes figures.
(function () {
  var roots = document.querySelectorAll('[data-tool="site_speed"]');
  if (!roots.length) return;

  function usd(n) {
    return '$' + Math.round(n).toLocaleString('en-US');
  }

  // Parse to a non-negative number, or null when empty/invalid. Only separators are
  // stripped, so a minus sign or stray letters are rejected rather than silently
  // coerced into a number that does not match what the field shows.
  function parseNum(raw) {
    var cleaned = String(raw).replace(/[\s,]/g, '');
    if (cleaned === '') return null;
    var n = Number(cleaned);
    return isFinite(n) && n >= 0 ? n : null;
  }

  function mount(root) {
    if (root.dataset.toolMounted) return;
    root.dataset.toolMounted = 'true';

    var liftPerSecond = Number(root.getAttribute('data-lift-per-second'));
    var maxSeconds = Number(root.getAttribute('data-max-seconds'));
    if (!isFinite(liftPerSecond) || !isFinite(maxSeconds)) return;

    var wizard = root.querySelector('[data-speed-wizard]');
    var resultCard = root.querySelector('[data-speed-result]');
    var stepNodes = root.querySelectorAll('[data-speed-step]');
    var errorSlot = root.querySelector('[data-speed-error]');
    var backBtn = root.querySelector('[data-speed-back]');
    var nextBtn = root.querySelector('[data-speed-next]');
    var copyBtn = root.querySelector('[data-speed-copy]');
    var restartBtn = root.querySelector('[data-speed-restart]');
    if (!wizard || !resultCard || !stepNodes.length || !nextBtn) return;

    var total = stepNodes.length;
    var step = 1;
    var copyTimer = null;

    var out = {};
    var outNodes = root.querySelectorAll('[data-speed-out]');
    for (var i = 0; i < outNodes.length; i++) {
      out[outNodes[i].getAttribute('data-speed-out')] = outNodes[i];
    }

    var fields = {};
    var fieldNodes = root.querySelectorAll('[data-speed-input]');
    for (var f = 0; f < fieldNodes.length; f++) {
      fields[fieldNodes[f].getAttribute('data-speed-input')] = fieldNodes[f];
    }

    function stepNode(n) {
      return root.querySelector('[data-speed-step="' + n + '"]');
    }

    // ── Math (src/lib/siteSpeed.ts) ────────────────────────────────────────
    function calcSecondsSaved(currentLoad, targetLoad) {
      return Math.min(Math.max(currentLoad - targetLoad, 0), maxSeconds);
    }

    function calcProjectedConversion(convRate, secondsSaved) {
      return convRate * (1 + secondsSaved * liftPerSecond);
    }

    function calcMonthlyRevenue(sessions, convRatePercent, aov) {
      return sessions * (convRatePercent / 100) * aov;
    }

    function calcResult(v) {
      var secondsSaved = calcSecondsSaved(v.currentLoad, v.targetLoad);
      var projectedConv = calcProjectedConversion(v.convRate, secondsSaved);
      var currentRevenue = calcMonthlyRevenue(v.sessions, v.convRate, v.aov);
      var projectedRevenue = calcMonthlyRevenue(v.sessions, projectedConv, v.aov);
      var monthlyGap = projectedRevenue - currentRevenue;

      return {
        secondsSaved: secondsSaved,
        projectedConv: projectedConv,
        currentRevenue: currentRevenue,
        projectedRevenue: projectedRevenue,
        monthlyGap: monthlyGap,
        annualGap: monthlyGap * 12
      };
    }

    // ── Wizard ─────────────────────────────────────────────────────────────
    function showStep(n) {
      step = n;
      for (var s = 0; s < stepNodes.length; s++) {
        stepNodes[s].hidden = Number(stepNodes[s].getAttribute('data-speed-step')) !== n;
      }

      var active = stepNode(n);
      if (out.step) out.step.textContent = String(n);
      if (out.total) out.total.textContent = String(total);
      if (out.tag && active) out.tag.textContent = active.getAttribute('data-speed-tag') || '';
      if (out.progress) out.progress.style.width = (n / total) * 100 + '%';
      if (backBtn) backBtn.hidden = n === 1;
      nextBtn.textContent = n === total ? 'See my number' : 'Next';

      var input = active && active.querySelector('[data-speed-input]');
      if (input) input.focus({ preventScroll: true });
    }

    function activeKey() {
      var active = stepNode(step);
      return active ? active.getAttribute('data-speed-key') : null;
    }

    function setError(message) {
      if (errorSlot) errorSlot.textContent = message;
    }

    function goNext() {
      var key = activeKey();
      if (!key || !fields[key]) return;

      if (parseNum(fields[key].value) == null) {
        setError('Enter a number of 0 or more to continue.');
        return;
      }
      setError('');

      if (step === total) {
        renderResult();
        return;
      }
      showStep(step + 1);
    }

    function goBack() {
      setError('');
      if (step > 1) showStep(step - 1);
    }

    function readValues() {
      return {
        sessions: parseNum(fields.sessions.value),
        currentLoad: parseNum(fields.currentLoad.value),
        targetLoad: parseNum(fields.targetLoad.value),
        convRate: parseNum(fields.convRate.value),
        aov: parseNum(fields.aov.value)
      };
    }

    var lastResult = null;
    var lastValues = null;

    function renderResult() {
      var values = readValues();
      var keys = ['sessions', 'currentLoad', 'targetLoad', 'convRate', 'aov'];
      for (var k = 0; k < keys.length; k++) {
        if (values[keys[k]] == null) {
          setError('Enter a number of 0 or more to continue.');
          showStep(k + 1);
          return;
        }
      }

      var result = calcResult(values);
      lastResult = result;
      lastValues = values;

      // Guard the bar scale: with zero sessions or zero AOV both revenues are 0.
      var maxRev = Math.max(result.currentRevenue, result.projectedRevenue, 1);

      if (out.monthlyGap) out.monthlyGap.textContent = usd(result.monthlyGap);
      if (out.heroNote) {
        out.heroNote.textContent =
          result.secondsSaved > 0
            ? 'Based on cutting ' +
              result.secondsSaved.toFixed(1) +
              's off your load time, ' +
              usd(result.annualGap) +
              ' a year.'
            : 'You are already at or ahead of your target load time. Holding that speed is what is at stake.';
      }
      if (out.currentConv) out.currentConv.textContent = values.convRate.toFixed(2) + '%';
      if (out.projectedConv) {
        out.projectedConv.textContent = result.projectedConv.toFixed(2) + '%';
      }
      if (out.currentRevenue) out.currentRevenue.textContent = usd(result.currentRevenue);
      if (out.projectedRevenue) {
        out.projectedRevenue.textContent = usd(result.projectedRevenue);
      }
      if (out.currentBar) {
        out.currentBar.style.width = (result.currentRevenue / maxRev) * 100 + '%';
      }
      if (out.projectedBar) {
        out.projectedBar.style.width = (result.projectedRevenue / maxRev) * 100 + '%';
      }
      if (out.annualGap) out.annualGap.textContent = usd(result.annualGap);

      wizard.hidden = true;
      resultCard.hidden = false;
      resultCard.classList.add('tool__reveal');
    }

    function startOver() {
      lastResult = null;
      lastValues = null;
      Object.keys(fields).forEach(function (key) {
        fields[key].value = '';
      });
      setError('');
      resultCard.hidden = true;
      resultCard.classList.remove('tool__reveal');
      wizard.hidden = false;
      showStep(1);
    }

    function copySummary() {
      if (!lastResult || !lastValues || !navigator.clipboard) return;

      var text =
        'Site Speed Revenue Calculator (Shero Commerce)\n' +
        'Monthly sessions: ' +
        lastValues.sessions.toLocaleString('en-US') +
        '\n' +
        'Current load time: ' +
        fields.currentLoad.value +
        's -> Target: ' +
        fields.targetLoad.value +
        's\n' +
        'Conversion rate: ' +
        lastValues.convRate.toFixed(2) +
        '% -> Projected: ' +
        lastResult.projectedConv.toFixed(2) +
        '%\n' +
        'Current monthly revenue: ' +
        usd(lastResult.currentRevenue) +
        '\n' +
        'Potential monthly revenue: ' +
        usd(lastResult.projectedRevenue) +
        '\n' +
        'Revenue left on the table: ' +
        usd(lastResult.monthlyGap) +
        ' / month (' +
        usd(lastResult.annualGap) +
        ' / year)';

      navigator.clipboard.writeText(text).then(function () {
        copyBtn.textContent = '✓ Copied!';
        copyBtn.classList.add('tool__btn--copied');
        clearTimeout(copyTimer);
        copyTimer = setTimeout(function () {
          copyBtn.textContent = 'Copy result summary';
          copyBtn.classList.remove('tool__btn--copied');
        }, 2500);
      });
    }

    nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);
    if (copyBtn) copyBtn.addEventListener('click', copySummary);
    if (restartBtn) restartBtn.addEventListener('click', startOver);

    Object.keys(fields).forEach(function (key) {
      fields[key].addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          goNext();
        }
      });
      fields[key].addEventListener('input', function () {
        setError('');
      });
    });

    // Sync the chrome to step 1 without stealing focus on page load.
    for (var s = 0; s < stepNodes.length; s++) {
      stepNodes[s].hidden = Number(stepNodes[s].getAttribute('data-speed-step')) !== 1;
    }
    if (backBtn) backBtn.hidden = true;
    if (out.total) out.total.textContent = String(total);
    if (out.progress) out.progress.style.width = (1 / total) * 100 + '%';
  }

  // Marked only after a clean mount, so free-tools.liquid reveals its fallback table if setup throws.
  for (var r = 0; r < roots.length; r++) {
    mount(roots[r]);
    roots[r].setAttribute('data-tool-ready', '');
  }
})();
